import * as actionTypes from '../actions/actionTypes';

const initialState = {
    isSignup: false,
    isLoading: false,
    userToken: null,
    companyKey: null,
    passwordResetSuccess: false,
    resetPasswordError: null,
    resetPasswordErrors: {},
    validationErrors: {},
    step: null,
    hash: null,
    checkedEmail: null,
    timer: null,
    alreadyRegistered: false,
};

const reducer = (state = initialState, {type, ...payload}) => {
    switch (type) {
        case actionTypes.LOAD_WIDGET_SETTINGS:
            const {companyAPIKey} = payload;
            return {
                ...state,
                companyKey: companyAPIKey
            };
        case actionTypes.CHECK_EMAIL:
            const {email: checkedEmail} = payload;
            return {
                ...state,
                isLoading: true,
                checkedEmail
            };
        case actionTypes.VERIFY_EMAIL:
        case actionTypes.FILL_PROFILE:
        case actionTypes.VERIFY_PASSWORD:
            return {
                ...state,
                isLoading: true
            };
        case actionTypes.CHECK_EMAIL_SUCCEEDED: {
            const {step, hash, timer, alreadyRegistered} = payload;
            return {
                ...state,
                isLoading: false,
                step,
                hash,
                timer,
                alreadyRegistered
            }
        }
        case actionTypes.VERIFY_EMAIL_SUCCEEDED: {
            const {step, hash} = payload;
            return {
                ...state,
                isLoading: false,
                step,
                hash
            };
        }
        case actionTypes.FILL_PROFILE_SUCCEEDED:
        case actionTypes.VERIFY_PASSWORD_SUCCEEDED:
        case actionTypes.RESTORE_SESSION_SUCCEEDED:
            const {userToken} = payload;
            return {
                ...state,
                isSignup: true,
                isLoading: false,
                step: null,
                hash: null,
                userToken
            };
        case actionTypes.CHECK_EMAIL_FAILED:
        case actionTypes.VERIFY_EMAIL_FAILED:
        case actionTypes.FILL_PROFILE_FAILED:
        case actionTypes.VERIFY_PASSWORD_FAILED: {
            const {validationErrors} = payload;
            return {
                ...state,
                isLoading: false,
                validationErrors
            };
        }
        case actionTypes.RESET_STEP:
        case actionTypes.REQUEST_PASSWORD_RESET:
            return {
                ...state,
                step: null,
                hash: null
            };
        case actionTypes.REQUEST_PASSWORD_RESET_SUCCEEDED:
        case actionTypes.RESET_PASSWORD_SUCCEEDED:
            return {
                ...state,
                passwordResetSuccess: true,
                resetPasswordValidationErrors: {}
            };
        case actionTypes.REQUEST_PASSWORD_RESET_REDIRECT:
            return {
                ...state,
                passwordResetSuccess: false
            };
        case actionTypes.REQUEST_PASSWORD_RESET_FAILED:
        case actionTypes.RESET_PASSWORD_FAILED:
            const {validationErrors, resetPasswordError} = payload;
            return {
                ...state,
                validationErrors,
                resetPasswordError
            };
        case actionTypes.RESET_PASSWORD_DISMISS_ERROR:
            return {
                ...state,
                resetPasswordError: null
            };
        case actionTypes.LOGOUT_SUCCEEDED:
            return {
                ...state,
                isSignup: false,
                userToken: null
            };
        case actionTypes.REQUEST_RESET_PASSWORD_CODE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case actionTypes.REQUEST_RESET_PASSWORD_CODE_SUCCESS: {
            const { timer, step } = payload;
            return {
                ...state,
                step,
                timer,
                isLoading: false,
            };
        }
        case actionTypes.REQUEST_RESET_PASSWORD_CODE_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case actionTypes.VERIFY_RESET_PASSWORD_CODE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case actionTypes.VERIFY_RESET_PASSWORD_CODE_SUCCESS: {
            const { step } = payload;
            return {
                ...state,
                step,
                isLoading: false,
            };
        }
        case actionTypes.VERIFY_RESET_PASSWORD_CODE_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case actionTypes.SET_RESET_PASSWORD: {
            return {
                ...state,
                isLoading: true,
                timer: null,
            };
        }
        case actionTypes.SET_RESET_PASSWORD_SUCCESS: {
            const { accessToken } = payload;
            return {
                ...state,
                step: null,
                hash: null,
                isSignup: true,
                userToken: accessToken,
                isLoading: false,
            };
        }
        case actionTypes.SET_RESET_PASSWORD_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        default:
            return state;
    }
};

export default reducer;
